<template>
  <div class="product-baby-video" v-b-scrollspy>
    <!-- bgVideoMixin Start -->
    <div class="baby-video">
      <template v-if="$i18n.locale() === 'ko'">
        <!-- ** lang KO Start ** -->
        <iframe width="560" height="315" src="https://www.youtube.com/embed/S3XI_d9zT_k" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <!-- ** lang KO End ** -->
      </template>
      <template v-else>
        <!-- ** lang EN Start ** -->
        <iframe width="560" height="315" src="https://www.youtube.com/embed/9lpuIo5b414" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <!-- ** lang EN Start ** -->
      </template>
    </div>
    <!-- bgVideoMixin End -->
  </div>
</template>

<script>
import { bgVideoMixin } from '../mixins/bgVideo';

export default {
  name: 'BabyVideo',
  data() {
    return {
      scrollY: 0,
      timer: null,
    };
  },
  mixins: [bgVideoMixin],
  created() {
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Baby Video CSS
    ------------------ */
  .product-baby-video {
  }

  .baby-video iframe,
  .baby-video object,
  .baby-video embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .baby-video {
    position: relative;
    padding-bottom: 43.35%;
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    max-width: 1520px;
    margin: 0 auto;
  }
</style>
